import React from "react";
import { connect } from "react-redux";

import { showToast, deleteData } from "Source/globalFunction";
import { DeleteModal } from "Source/globalComponents";

@connect(store => {
    return {
        workstreams: store.workstreams,
        project: store.project
    };
})

class DeleteWorkstream extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { workstreams, dispatch } = this.props;
        const typeValue = workstreams.selected.workstream;

        const handleDelete = () => {
            const url = `/api/workstream/${workstreams.selected.id}`;
            const params = { isDeleted: 0 };
            
            dispatch({ type: "SET_SCREEN_LOADER", Loading: true });

            deleteData(url, {params}, response => {
                if(response) {
                    dispatch({type: "REMOVE_WORKSTREAMS_ITEM", id: workstreams.selected.id});
                    dispatch({type: "UPDATE_WORKSTREAMS_SELECTED", selected: {}});
                    dispatch({type: "REMOVE_DELETED_WORKSTREAM_LIST", id: workstreams.selected.id});
                }

                dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
    
                showToast("success", "Workstream successfully deleted.");
                $(`#deleteWorkstream`).modal("hide");
            });
        }

        const handleCancelDelete = () => {
            dispatch({type: "UPDATE_WORKSTREAMS_SELECTED", selected: {}});
            $(`#deleteWorkstream`).modal("hide");
        }

        return (
            <DeleteModal
                id="deleteWorkstream"
                type="workstream"
                type_value={typeValue}
                delete_function={handleDelete}
                cancel_function={handleCancelDelete}
            />
        );
    }
}

export default DeleteWorkstream;